import { render } from "./AppModal.vue?vue&type=template&id=63f05763&ts=true"
import script from "./AppModal.vue?vue&type=script&lang=ts"
export * from "./AppModal.vue?vue&type=script&lang=ts"

import "./AppModal.vue?vue&type=style&index=0&id=63f05763&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__